import { render, staticRenderFns } from "./UpsellRunnitsPlanDialog.vue?vue&type=template&id=00534dd0"
import script from "./UpsellRunnitsPlanDialog.vue?vue&type=script&lang=ts"
export * from "./UpsellRunnitsPlanDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports